<a class="whatsapp" [href]="'http://wa.me/55' + getNumeroZap()" [class.light]="light">
  <i class="fab fa-whatsapp mr-1" [class.fa-2x]="!light"></i>
  <ng-container *ngIf="getNumeroZap().length === 11">
    {{getNumeroZap() | mask: '(99) 9-9999-9999'}}
  </ng-container>

  <ng-container *ngIf="getNumeroZap().length === 10">
    {{getNumeroZap() | mask: '(99) 9999-9999'}}
  </ng-container>
</a>
